import * as React from 'react';

import { config } from '@shopee-user/platform';
import { Locale } from '@shopee-user/global';

// Components
import { FoodDriverHelpTextSpan } from '../components/FoodDriverHelpTextSpan';

/**
 * Text only. Mainly used in placeholder
 */
export const HelpSpan = ({ text }: { text: string }) => {
  // FIXME: remove this once we have help link for PH
  if (config.LOCALE === Locale.PH) {
    return null;
  } else {
    return <FoodDriverHelpTextSpan>{text}</FoodDriverHelpTextSpan>;
  }
};
